
/**
 * append script dynamically
 * @param {string} src - script source
 * @param {Function} afterLoad - the code that should be called after script is loaded
 */
export const downloadJSAtOnload = (src: string, afterLoad?: Function) => {

    const existingScript = document.querySelector(`script[src="${src}"]`) as HTMLScriptElement;

    if (existingScript)
        return;

    const element = document.createElement('script') as HTMLScriptElement;
    if (afterLoad) {
        // @ts-ignore
        element.onload = afterLoad;
    }
    element.src = src;
    document.body.appendChild(element);
};

/**
 * load scripts like impact radius and other third parties after page load to improve performance
 * @param {string} src - script source
 * @param {Function} afterLoad - the code that should be called after script is loaded
 */
export const deferScript = (src: string, afterLoad?: Function) => {
    window.addEventListener('load', () => {
        downloadJSAtOnload(src, afterLoad);
    }, false);
};